import { GoogleLogo, FacebookLogo, AppleLogo } from "@phosphor-icons/react";
import { toast } from "sonner";
import { startGoogleSignIn } from "@/pages/AuthCallback";

const Btn = ({ Icon, label, onClick, testid, disabled, title }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    title={title}
    data-testid={testid}
    className={`flex w-full items-center justify-center gap-2 border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-[#0F172A] transition-colors duration-150 ${disabled ? "cursor-not-allowed opacity-50" : "hover:border-[#002FA7] hover:text-[#002FA7]"}`}
  >
    <Icon size={18} weight="fill" /> {label}
  </button>
);

export const SocialSignIn = ({ label = "Or continue with" }) => (
  <div data-testid="social-signin" className="mt-6">
    <div className="flex items-center gap-3">
      <span className="h-px flex-1 bg-border" />
      <span className="overline text-[0.6rem] text-slate-400">{label}</span>
      <span className="h-px flex-1 bg-border" />
    </div>
    <div className="mt-4 space-y-2">
      <Btn Icon={GoogleLogo} label="Continue with Google" testid="google-signin-button" onClick={startGoogleSignIn} />
      <div className="grid grid-cols-2 gap-2">
        <Btn
          Icon={FacebookLogo}
          label="Facebook"
          testid="facebook-signin-button"
          title="Facebook sign-in needs a Meta app ID and secret"
          onClick={() => toast.info("Facebook sign-in is ready to switch on — it needs your Meta App ID and Secret first")}
        />
        <Btn
          Icon={AppleLogo}
          label="Apple"
          testid="apple-signin-button"
          title="Apple sign-in needs an Apple Developer account"
          onClick={() => toast.info("Apple sign-in needs an Apple Developer account, a Services ID and a private key")}
        />
      </div>
    </div>
  </div>
);
